import { Reducer } from 'redux';
import { Actions } from 'store/actions/subscription';
import {
  SUBSCRIPTION_LOADING,
  SUBSCRIPTION_LOADED,
  SUBSCRIPTION_LOADING_FAILED,
  SUBSCRIPTION_PAYMENT_PROCESSING,
  SUBSCRIPTION_PAYMENT_COMPLETE,
  SUBSCRIPTION_PAYMENT_FAILED,
  SUBSCRIPTION_RESET_MESSAGE,
} from 'store/types/subscription.type';

import { RootReducerType } from './index';

export type State = {
  isLoading: boolean;
  error: string;
  subscription: any;
  message: string;
};

const initialState: State = {
  subscription: { is_subscription_deactive: true },
  error: '',
  message: '',
  isLoading: false,
};

export const subscriptionReducer: Reducer<State, Actions> = (state = initialState, action) => {
  switch (action.type) {
    case SUBSCRIPTION_LOADING:
      return { ...state, isLoading: true, subscription: { is_subscription_deactive: true }, error: '' };
    case SUBSCRIPTION_LOADED:
      return { ...state, isLoading: false, subscription: action.payload };
    case SUBSCRIPTION_LOADING_FAILED:
      return { ...state, isLoading: false, error: action.error };
    case SUBSCRIPTION_PAYMENT_PROCESSING:
      return { ...state, isLoading: true, error: '', message: '' };
    case SUBSCRIPTION_PAYMENT_COMPLETE:
      return { ...state, isLoading: false, message: action.payload };
    case SUBSCRIPTION_PAYMENT_FAILED:
      return { ...state, isLoading: false, error: action.error };
    case SUBSCRIPTION_RESET_MESSAGE:
      return { ...state, error: '', message: '' };

    default:
      return state;
  }
};

export const subscriptionSelector = (state: RootReducerType) => state.subscription;
export default subscriptionReducer;
